<template>
  <v-container class="transparent" fluid>
    <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>
    <v-sheet class="pa-2" min-height="600" rounded>
      <v-row>
        <v-col class="text-left" cols="12">
          <v-btn v-show="!filtersVisible"
                 dark elevation="0" small
                 style="text-transform: none"
                 @click="filtersVisible = true">
            Search Items and figure configuration
            <v-icon small>mdi-chevron-double-right</v-icon>
          </v-btn>
        </v-col>
        <v-col :cols="filtersVisible ? 2 : 0">
          <v-fade-transition>
            <v-sheet v-if="filtersVisible" class="pa-2" elevation="2" outlined rounded>
              <v-row>
                <v-col cols="12">

                  <v-sheet class="font-weight-bold" style="font-size: 1.1rem;">
                    Search Items:
                    <v-btn class="float-end"
                           dark elevation="0" small
                           style="text-transform: none"
                           @click="filtersVisible = false">
                      Hide
                      <v-icon small>mdi-chevron-double-left</v-icon>
                    </v-btn>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
                  <v-sheet>
                    <div class="font-weight-bold" style="color: red; font-size: 0.9rem"> Substrate, site, and optional
                      value separated by space or tab.
                      <helpicon
                          tooltip-text="Gene can be a gene symbol, UniProt ID, or Ensembl protein ID. Value is optional but required for GSEA."></helpicon>
                    </div>
                    <div v-if="alert_info" class="red--text" style="font-size: 0.7rem; ">
                      <v-icon color="red" small>mdi-alert-circle-outline</v-icon>
                      {{ alert_info }}
                    </div>

                  </v-sheet>
                  <v-card-text>
                    <v-textarea
                        v-model="batch_search"
                        clearable
                        outlined
                    />
                    <v-row class="mt-n6">
                      <v-col class="d-flex align-center" cols="12">
                        <span class="text-caption mr-2 font-weight-bold">Examples:</span>
                        <v-btn class="mr-2" color="primary" dense text x-small @click="loadExample(1)">1</v-btn>
                        <v-btn color="primary" dense text x-small @click="loadExample(2)">2</v-btn>
                        <v-btn color="primary" dense text x-small @click="loadExample(3)">3</v-btn>
                      </v-col>

                      <v-col class="text-center" cols="12">
                        <v-btn class="pa-4 ma-4" color="primary" :disabled="!canSubmit" small @click="submitBatchSearch">Apply</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-sheet elevation="1" outlined rounded>
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header>Figure Configuration</v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-select
                                  v-model="plotType"
                                  :items="['Bar plot', 'Scatter plot']"
                                  dense
                                  label="Plot Type"
                                  outlined
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                  v-if="plotType === 'Bar plot'"
                                  v-model="barX"
                                  :items="barXOptions"
                                  dense
                                  label="X Axis"
                                  outlined
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                  v-if="plotType === 'Scatter plot'"
                                  v-model="scatterX"
                                  :items="scatterOptionsFiltered"
                                  dense
                                  label="X Axis"
                                  outlined
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                  v-if="plotType === 'Bar plot'"
                                  v-model="barY"
                                  :items="barYOptions"
                                  dense
                                  label="Y Axis"
                                  multiple
                                  outlined
                                  small-chips
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                  v-if="plotType === 'Scatter plot'"
                                  v-model="scatterY"
                                  :items="filteredScatterYOptions"
                                  dense
                                  label="Y Axis"
                                  outlined
                              />

                            </v-col>
                            <v-col cols="12">
                              <v-sheet v-if="plotType === 'Scatter plot'">
                                Quick Style:
                                <v-btn
                                    v-if="isThreeColumn"
                                    class="ma-1"
                                    outlined
                                    x-small
                                    style="text-transform: none"
                                    @click="applyQuickStyle({
                                    x: 'Publication score',
                                    y: 'User input value',
                                    colorField: 'data_score'
                                  })"
                                >
                                  User vs Publication Score
                                </v-btn>

                                <v-btn
                                    v-if="isThreeColumn"
                                    class="ma-1"
                                    outlined
                                    x-small
                                    style="text-transform: none"
                                    @click="applyQuickStyle({
                                    x: 'Data score',
                                    y: 'User input value',
                                    colorField: 'publication_score'
                                  })"
                                >
                                  User vs Data Score
                                </v-btn>
                                <v-btn
                                    class="ma-1"
                                    outlined
                                    x-small
                                    block
                                    @click="applyQuickStyle({
                                    x: 'Data score',
                                    y: 'Publication score'
                                  })"
                                    style="text-transform: none"
                                >
                                  Publication vs Data Score
                                </v-btn>

                                <v-btn
                                    class="ma-1"
                                    outlined
                                    x-small
                                    style="text-transform: none"
                                    @click="applyQuickStyle({
                                    x: 'Publication score',
                                    y: 'Data score'
                                  })"
                                >
                                  Data vs Publication Score
                                </v-btn>


                                <v-switch
                                    v-if="isThreeColumn"
                                    v-model="useColor"
                                    dense
                                    x-small
                                    hide-details
                                    label="Enable color"
                                />
                                <v-switch
                                    v-model="useLabel"
                                    dense
                                    x-small
                                    hide-details
                                    label="Enable Label"
                                />


                              </v-sheet>

                            </v-col>
                            <v-btn class="pa-2" color="primary" small @click="handleApply">
                              Apply
                            </v-btn>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-sheet>
          </v-fade-transition>
        </v-col>

        <v-col :cols="filtersVisible ? 10 : 12">
          <v-sheet class="pa-2" elevation="2" outlined rounded>
            <v-tabs v-model="selectedTab" align-with-title >
              <v-tab style="text-transform: none">
                <v-icon left>mdi-table-large</v-icon>
                Table Result
              </v-tab>

              <v-tab style="text-transform: none">
                <v-icon left>mdi-graphql</v-icon>
                Enrichment Analysis
              </v-tab>

              <v-tab v-if="showFigureTab" style="text-transform: none">
                <v-icon left>mdi-chart-bar-stacked</v-icon>
                Figure Priority Analysis
              </v-tab>
            </v-tabs>


            <v-tabs-items v-model="selectedTab">

              <!-- ================= Table ================= -->
              <v-tab-item>

                <template v-if="searchState === 'idle'">
                  <v-row align="center" justify="center" style="height: 500px">
                    <v-col class="text-center grey--text">
                      <v-icon large color="grey">mdi-information-outline</v-icon>
                      <div class="mt-2">
                        Please enter substrate and site (and optional value) on the left panel and click Apply to start analysis.
                      </div>
                    </v-col>
                  </v-row>
                </template>

                <template v-else-if="searchState === 'loading'">
                  <v-row align="center" justify="center" style="height: 500px">
                    <v-progress-circular
                        indeterminate
                        size="50"
                        width="4"
                        color="primary"
                    />
                  </v-row>
                </template>

                <template v-else-if="searchState === 'empty'">
                  <v-row align="center" justify="center" style="height: 500px">
                    <v-col class="text-center grey--text">
                      <v-icon x-large>mdi-database-remove</v-icon>
                      <div class="mt-2">No result found</div>
                    </v-col>
                  </v-row>
                </template>

                <template v-else-if="searchState === 'error'">
                  <v-row align="center" justify="center" style="height: 500px">
                    <v-col class="text-center red--text">
                      <v-icon x-large color="red">mdi-alert-circle-outline</v-icon>
                      <div class="mt-2">{{ alert_info || 'Search failed' }}</div>
                    </v-col>
                  </v-row>
                </template>



                <template v-else-if="searchState === 'done'">
                  <v-sheet class="ma-2 pa-2">
                    <v-btn
                        v-if="hasResults"
                        :loading="exporting"
                        class="mx-4 mt-6"
                        color="success"
                        small
                        @click="handleExport"
                    >
                      <v-icon left small>mdi-download</v-icon>
                      Export CSV
                    </v-btn>

                    <batch-table
                        :tdata="tableData"
                        :total="total"
                    />
                  </v-sheet>
                </template>

              </v-tab-item>


              <v-tab-item>
                <enrichment-for-batch-search
                    :batch_search="batch_search"
                />
              </v-tab-item>

              <!-- ================= Figure ================= -->
              <v-tab-item v-if="showFigureTab">

                <template v-if="isEmpty">
                  <div class="text-center grey--text mt-6">
                    No data available. Please adjust parameters and try again.
                  </div>
                </template>

                <template v-else>
                  <v-sheet class="ma-6 pa-6" min-height="500px" outlined>
                    <bar-for-batch-search
                        v-if="plotType === 'Bar plot' && filteredBarData.length > 0"
                        :tdata="filteredBarData"
                    />

                    <ptm-score-scatter-plot
                        v-else-if="plotType === 'Scatter plot' && score.length > 0"
                        :colorField="useColor ? colorField : null"
                        :showLabels="useLabel"
                        :tdata="score"
                        :xField="getFieldName(scatterX)"
                        :yField="getFieldName(scatterY)"
                    />



                    <!--                      <ptm-score-scatter-plot-->
                    <!--                          v-else-if="plotType === 'Scatter plot' && score.length > 0"-->
                    <!--                          :tdata="score"-->
                    <!--                          :xField="getFieldName(scatterX)"-->
                    <!--                          :yField="getFieldName(scatterY)"-->
                    <!--                      />-->
                  </v-sheet>
                </template>
              </v-tab-item>

            </v-tabs-items>
          </v-sheet>
        </v-col>

      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import Axios from "axios";

import Helpicon from "@/components/sub/helpicon.vue";
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import HomeTable from "@/components/HomeTable.vue";
import PtmScoreScatterPlot from "@/components/PtmScoreScatterPlot.vue";
import BarForBatchSearch from "@/components/BarForBatchSearch.vue";
import EnrichmentForBatchSearch from "@/components/EnrichmentForBatchSearch.vue";
import BatchTable from "@/components/BatchTable.vue";
import {examples} from '@/config/exampleList'
import {apiprefix} from "@/main";

const BAR_FIELD_MAP = {
      'Text mining': 'text_evidence_count',
      'Figure mining': 'figure_evidence_count',
      'PTMAtlas datasets': 'experiment_evidence_count',
      'CPTAC datasets': 'cohort_evidence_count'
    }

export default {
  name: "batchSearch",
  components: {
    BatchTable,
    EnrichmentForBatchSearch,
    PtmScoreScatterPlot,
    HomeTable,
    BarForBatchSearch,
    BreadCrumb, Helpicon,
  },
  data() {
    return {
      plotType: 'Scatter plot',
      showFigureTab: false,
      barX: 'Top20',
      barY: ['All'],
      _lastBarY: [],
      updatingBarY: false,
      barXOptions: ['Top10',  'Top20', 'Top30', 'Top40', 'Top50'],
      barYOptions: ['All', 'Text mining', 'Figure mining', 'PTMAtlas datasets', 'CPTAC datasets'],
      scatterX: null,
      scatterY: null,
      scatterOptions: ['Publication score', 'Data score', 'User input value'],
      filtersVisible: true,
      alert_info: '',
      tableData: [],
      total: 0,
      batch_search: "",
      score: [],
      selectedTab: 0,
      exporting: false,
      currentGenesSites: [],
      useColor: false,
      useLabel:true,
      colorField: null,      // 'publication_score' | 'data_score' | 'user_input_score'
      colorSource: null,
      searchState: 'idle',
    }
  },
  methods: {

    handleApply() {
      if (
          (this.plotType === 'Scatter plot' && !this.score.length) ||
          (this.plotType === 'Bar plot' && !this.tableData.length)
      ) return

      this.showFigureTab = true
      this.selectedTab = 2
    },

    getFieldName(label) {
      return label === 'Publication score' ? 'publication_score'
          : label === 'Data score' ? 'data_score'
              : 'user_input_score'
    },

    loadExample(num) {
      this.batch_search = examples[num];
      this.submitBatchSearch();
    },

    formatToDict(inputText) {
      const lines = inputText.split(/[\n,]+/).map(l => l.trim()).filter(Boolean);
      const uniqueLines = [...new Set(lines)];

      return uniqueLines
          .map(line => {
            const tokens = line.split(/[\s:]+/).map(t => t.trim()).filter(Boolean);
            const substrate = tokens[0]?.toUpperCase() || '';
            const site = tokens[1]?.toUpperCase() || '';
            const third = tokens[2];
            const hasThirdColumn = tokens.length >= 3;
            const thirdIsValidNumber = third !== undefined && !isNaN(Number(third));
            const valid = substrate && site && (!hasThirdColumn || thirdIsValidNumber);

            return valid ? {
              substrate,
              site,
              user_input_score: thirdIsValidNumber ? Number(third) : null
            } : null;
          })
          .filter(item => item !== null);
    },
    async submitBatchSearch() {
      const structured = this.formatToDict(this.batch_search);

      if (!structured.length) {
        this.alert_info = 'No valid input.';
        this.searchState = 'error';
        return;
      }

      this.alert_info = '';
      this.searchState = 'loading';
      this.showFigureTab = false;
      this.selectedTab = 0;

      this.currentGenesSites = structured;

      try {
        const response = await Axios.post(`${apiprefix}/api/batchsearch/`, {
          genesSites: this.currentGenesSites
        });

        if (response.data.status) {
          this.tableData = response.data.data.summary_data;
          this.score = response.data.data.score;
          this.total = response.data.data.total;

          this.searchState = this.total > 0 ? 'done' : 'empty';
        } else {
          this.alert_info = 'Search failed.';
          this.searchState = 'error';
        }
      } catch (error) {
        this.alert_info = error.response?.data?.detail || error.message;
        this.searchState = 'error';
      }
    },

    async handleExport() {
      if (!this.currentGenesSites || !this.currentGenesSites.length) {
        this.alert_info = 'No data to export.';
        return;
      }

      this.exporting = true;

      try {
        const response = await Axios.post(`${apiprefix}/api/batchsearch/export`,
            {genesSites: this.currentGenesSites},
            {
              responseType: 'blob',
              timeout: 120000
            }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = `batch_search_${Date.now()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        console.log('Export successful');
      } catch (error) {
        console.error('Export error:', error);
        this.alert_info = error.response?.data?.detail || error.message || 'Export failed.';
      } finally {
        this.exporting = false;
      }
    },
    getRemainingScoreField(xLabel, yLabel) {
      if (!this.isThreeColumn) return null

      const used = new Set([
        this.getFieldName(xLabel),
        this.getFieldName(yLabel),
      ])

      const all = [
        'publication_score',
        'data_score',
        'user_input_score',
      ]

      const remaining = all.filter(f => !used.has(f))
      return remaining.length === 1 ? remaining[0] : null
    },
    syncColorWithAxes() {
      if (!this.useColor) return

      const xField = this.getFieldName(this.scatterX)
      const yField = this.getFieldName(this.scatterY)

      if (this.colorField === xField || this.colorField === yField) {
        const autoField = this.getRemainingScoreField(this.scatterX, this.scatterY)
        if (autoField) {
          this.colorField = autoField
          this.colorSource = 'auto'
        } else {
          this.useColor = false
          this.colorField = null
          this.colorSource = null
        }
      }

      if (this.colorSource === 'auto') {
        const autoField = this.getRemainingScoreField(this.scatterX, this.scatterY)
        this.colorField = autoField
      }
    },
    applyQuickStyle(preset) {
      this.scatterX = preset.x
      this.scatterY = preset.y

      if (preset.colorField) {
        this.colorField = preset.colorField
        this.colorSource = 'preset'
      }
    },
    async loadDataFromQuery() {
      const inputRaw = this.$route.query.input || '';

      if (!inputRaw) {
        this.batch_search = '';
        this.tableData = [];
        this.score = [];
        this.total = 0;
        this.searchState = 'idle';
        return;
      }

      try {
        this.batch_search = inputRaw;

        const structured = this.formatToDict(this.batch_search);

        if (!structured.length) {
          this.alert_info = 'Invalid input from URL parameters.';
          return;
        }

        this.currentGenesSites = structured;
        await this.submitBatchSearch();

      } catch (error) {
        console.error('Route update error:', error);
        this.alert_info = error.message || 'Failed to load route data.';
      }
    }
  },
  computed: {
    breadcrumbData() {
      return [
        {text: "Home", disabled: false, to: "/"},
        {text: "Batch Search", disabled: true}
      ];
    },

    hasResults() {
      return this.tableData.length > 0;
    },

    isEmpty() {
      return (
          (this.plotType === 'Bar plot' && this.filteredBarData.length === 0) ||
          (this.plotType === 'Scatter plot' && this.score.length === 0)
      )
    },

    filteredScatterYOptions() {
      return this.scatterOptionsFiltered.filter(option => option !== this.scatterX);
    },

    scatterOptionsFiltered() {
      const baseOptions = ['Publication score', 'Data score'];
      return this.isThreeColumn ? [...baseOptions, 'User input value'] : baseOptions;
    },

    isThreeColumn() {
      const lines = this.batch_search.split(/[\n,]+/)
          .map(l => l.trim())
          .filter(Boolean);
      return lines.some(line => {
        const tokens = line.split(/[\s:]+/).map(t => t.trim()).filter(Boolean);
        return tokens.length >= 3;
      });
    },

    filteredBarData() {
      if (!this.tableData.length) return []

      const N = parseInt(this.barX.replace('Top', ''), 10)

      const allFields = Object.values(BAR_FIELD_MAP)

      if (
          (this.barY.length === 1 && this.barY[0] === 'All') ||
          this.barY.length === allFields.length
      ) {
        return [...this.tableData]
            .sort((a, b) => b.evidence_total - a.evidence_total)
            .slice(0, N)
            .map(item => ({
              internal_id: item.internal_id,
              id: item.id,
              ptm_type: item.ptm_type,
              evidence_total: item.evidence_total,
              text_evidence_count: item.text_evidence_count,
              figure_evidence_count: item.figure_evidence_count,
              experiment_evidence_count: item.experiment_evidence_count,
              cohort_evidence_count: item.cohort_evidence_count
            }))
      }

      const selectedFields = this.barY
          .map(label => BAR_FIELD_MAP[label])
          .filter(Boolean)

      return [...this.tableData]
          .map(item => {
            const combined = selectedFields.reduce(
                (sum, field) => sum + (item[field] || 0),
                0
            )
            return {
              ...item,
              _combined_score: combined
            }
          })
          .sort((a, b) => b._combined_score - a._combined_score)
          .slice(0, N)
          .map(item => {
            const result = {
              internal_id: item.internal_id,
              id: item.id,
              ptm_type: item.ptm_type
            }
            selectedFields.forEach(field => {
              result[field] = item[field] || 0
            })

            return result
          })
    },
    canSubmit() {
      return this.batch_search.trim().length > 0
    }

  },

  watch: {
    barY(val) {
      if (this.updatingBarY) return;
      this.updatingBarY = true;
      if (val.includes('All') && val.length > 1 && this._lastBarY.includes('All')) {
        this.barY = val.filter(v => v !== 'All');
      } else if (val.includes('All') && !this._lastBarY.includes('All')) {
        this.barY = ['All'];
      }
      this._lastBarY = [...this.barY];
      this.updatingBarY = false;
    },
    useColor(val) {
      if (!val) {
        this.colorField = null
        this.colorSource = null
        return
      }

      if (this.colorField && this.colorSource === 'preset') {
        return
      }

      const autoField = this.getRemainingScoreField(this.scatterX, this.scatterY)
      if (autoField) {
        this.colorField = autoField
        this.colorSource = 'auto'
      } else {
        this.useColor = false
      }
    },
    scatterX() {
      this.syncColorWithAxes()
    },
    scatterY() {
      this.syncColorWithAxes()
    },
      '$route.query': {
        handler() {
          this.loadDataFromQuery();
        },
        immediate: true
      }
  },
  created() {
    this._lastBarY = [];
  },


}

</script>

<style lang="scss" scoped></style>
